import { CompanyRanking } from './company-ranking/CompanyRanking';
import styles from './IndustryDrawerContent.module.scss';
import { MonthlySentiment } from './monthly-sentiment/MonthlySentiment';
import { RecentUpdates } from './recent-updates/RecentUpdates';
import { UpcomingEarnings } from './upcoming-earnings/UpcomingEarnings';

export interface IndustryDrawerContentProps {
  themeId: string;
}

export const IndustryDrawerContent = ({
  themeId,
}: IndustryDrawerContentProps) => {
  return (
    <div className={styles.root}>
      <RecentUpdates themeId={themeId} />
      <CompanyRanking themeId={themeId} />
      <UpcomingEarnings themeId={themeId} />
      <MonthlySentiment themeId={themeId} />
    </div>
  );
};
